var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgFileImport = function SvgFileImport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 20",
    fill: "currentColor"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#file-import_svg__file-import_svg__clip0_4990_14807)",
    stroke: "#48525C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.666 2.5v3.333a.833.833 0 00.834.834h3.333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.167 10.833V4.167A1.667 1.667 0 017.832 2.5h5.833l4.167 4.167v9.166a1.666 1.666 0 01-1.666 1.667h-4.584m-7.917-1.667H9.5m0 0l-2.5-2.5m2.5 2.5l-2.5 2.5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "file-import_svg__file-import_svg__clip0_4990_14807"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2)",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgFileImport;